/**
 * Playready HTTP Headers.
 *
 * @group DRM
 *
 * @beta
 */
export const HTTP_HEADERS = 'HttpHeaders';
